
import { takeUntil, mergeMap } from 'rxjs/operators'
import { SEARCH_CITIES, SEARCH_LOCATIONS, setCitiesActionCreator, setLocationsActionCreator } from 'actions/locationsActions'
import { get } from 'helpers/observableAjaxHelpers'
import { SEARCH_CITIES_URL, SEARCH_LOCATIONS_URL } from 'interfaces/ajax'
import { Epic } from 'interfaces/middleware'
import { combineEpics } from 'redux-observable'
import { byType } from 'rxOperators/byType'
import { mapSafe } from 'rxOperators/mergeMapSafe'


const searchLocationsEpic: Epic = (action$) => {
  const search$ = action$
    .pipe(byType(SEARCH_LOCATIONS))

  return search$.pipe(
    mergeMap(({ payload: { id, query }}) => (
      get(SEARCH_LOCATIONS_URL, { name: query }).pipe(
        takeUntil(search$))
        .pipe(mapSafe(({ response }) =>
          setLocationsActionCreator(response, id, query)
        ))
    )))
}

const searchCitiesEpic: Epic = (action$) => {
  const search$ = action$
    .pipe(byType(SEARCH_CITIES))

  return search$.pipe(
    mergeMap(({ payload: { id, query }}) => (
      get(SEARCH_CITIES_URL, { name: query }).pipe(
        takeUntil(search$))
        .pipe(mapSafe(({ response }) =>
          setCitiesActionCreator(response, id, query)
        ))
    )))
}

export default combineEpics(
  searchLocationsEpic,
  searchCitiesEpic
)
